import { UserListParams } from '../api/types';

export const queryKeys = {
  // Companies
  companies: ['companies'] as const,
  company: (id: string) => ['company', id] as const,
  clientCompanies: (ids: string[]) => ['clientCompanies', ids] as const,

  // Users
  users: (params?: UserListParams) => ['users', params] as const,
  user: (id: string) => ['user', id] as const,
  userProfile: ['user-profile'] as const,

  // Projects
  project: (id: string) => ['project', id] as const,
  companyProject: (companyId: string) => ['companyProject', companyId] as const,
  projectFields: (id: string) => ['projectFields', id] as const,
  projectCarrierMappings: (id: string) => ['projectCarrierMappings', id] as const,

  // Shipments
  shipment: (id: string) => ['shipment', id] as const,
  projectShipments: (projectId: string, searchParams?: string) =>
    ['shipments', 'project', projectId, searchParams] as const,
  shipmentEvents: (shipmentId: string) => ['shipmentEvents', shipmentId] as const,
  projectShipmentsCustomFields: (projectId: string, fieldKey: string) =>
    ['projectShipmentsCustomFields', projectId, fieldKey] as const,

  // Tracking Jobs
  trackingJobs: ['trackingJobs'] as const,
  trackingJob: (shipmentId: string) => ['trackingJobs', 'shipment', shipmentId] as const,

  // Files
  files: (projectId: string) => ['files', 'project', projectId] as const,
  fileStats: (projectId: string) => ['fileStats', 'project', projectId] as const,

  // Carriers
  carriers: ['carriers'] as const,
  carrierIntegrations: (id: string) => ['carrierIntegrations', id] as const,

  // Share Links
  sharedLink: (id: string | null) => ['sharedLink', id] as const,

  // Marine Data
  marineShipsArea: (bounds: any) => ['marine', 'ships', 'area', bounds] as const,
  marineShipEvents: (shipId: number, type: string) => ['marine', 'ship', shipId, type] as const,
  marineShipPositionHistory: (shipId: number, filters: any) =>
    ['marine', 'ship', shipId, 'positions', filters] as const,
  marinePoisArea: (bounds: any) => ['marine', 'pois', 'area', bounds] as const,

  // Search
  searchServices: (filters: any) => ['search', 'services', filters] as const,
  searchPath: (start: string, end: string, via: string[]) => ['search', 'path', start, end, via] as const,

  // Timeline
  shipmentProcessingStats: ['shipmentProcessingStats'] as const,
} as const;
